module.exports = __webpack_public_path__ + "static/media/settings.207dffe3.png";